import type { SoundKey } from '@troia-v3/types';

import { playMessageSound } from '@/modules/chat/utils/messageSound';
import { playQueueSound } from '@/modules/chat/utils/queueSound';

/**
 * Mapping `SoundKey` → função de play.
 *
 * Espelha o tipo `SoundKey` do `@troia-v3/types`. Adicionar som novo:
 *   1. estender `SoundKey` no types package
 *   2. adicionar arquivo em `public/assets/notifications/audio/`
 *   3. criar helper `playXSound()` no módulo apropriado (ex: `modules/leads/utils/leadSound.ts`)
 *   4. registrar aqui
 *
 * `Partial` permite que tipos novos sejam aceitos pelo TS antes do player
 * existir — nessa janela a função `playSoundByKey` é no-op pra essa key.
 */
const players: Partial<Record<SoundKey, () => void>> = {
  message: playMessageSound,
  queue: playQueueSound,
};

/**
 * Toca o som correspondente a `key`. No-op se não houver player registrado
 * (caso de defensive programming pra rolagens onde o backend conhece um tipo
 * que o frontend ainda não mapeou).
 */
export const playSoundByKey = (key: SoundKey): void => {
  const player = players[key];
  if (player) player();
};
